import constate from 'constate';
import { useState } from 'react';

import { ICorporateUserAutocomplete } from 'corporate/types';
import { IBaseQuote } from 'quotes/types';

const useAddBomPartsToQuote = () => {
  const [selectedContact, setSelectedContact] = useState<ICorporateUserAutocomplete | null>(null);
  const [selectedQuote, setSelectedQuote] = useState<IBaseQuote | null>(null);

  return {
    selectedContact,
    setSelectedContact,
    selectedQuote,
    setSelectedQuote,
  };
};

export const [AddBomPartsToQuoteProvider, useAddBomPartsToQuoteContext] =
  constate(useAddBomPartsToQuote);
